import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Progress from 'components/common/Progress';

const styles = () => ({
  root: {
    position: 'relative',
    height: '100%',
    textAlign: 'center',
  },
  img: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

class DocumentsViewImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentWillMount() {
    fetch(this.props.src).then(() => {
      this.setState({ loading: false });
      this.props.onLoad();
    });
  }

  render() {
    const { loading } = this.state;
    const { classes, src, alt } = this.props;
    return (
      <div className={classes.root}>
        {loading ? (
          <Progress />
        ) : (
          <img
            className={classes.img}
            src={src}
            alt={alt}
          />
        )}
      </div>
    );
  }
}

DocumentsViewImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsViewImage.defaultProps = {
  onLoad: () => {},
};

export default withStyles(styles)(DocumentsViewImage);



// WEBPACK FOOTER //
// ./src/components/common/DocumentsViewDialog/DocumentsViewImage.js